<template>
  <div class="tab_content">
    <p class="tab_title">标的信息</p>
    <div class="tab_form">
      <div v-for="(target, idx) in bdxxs" :key="idx" class="target-block">
        <div class="target-block-header">
          <span class="block-index">标的 {{ idx + 1 }}</span>
          <el-button
            v-if="bdxxs.length > 1"
            type="danger"
            size="small"
            @click="removeTarget(idx)"
          >删除</el-button>
        </div>

        <el-form :ref="'form_' + idx" :model="target" label-width="180px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                label="知识产权类型"
                prop="zscqlx"
                :rules="[{ required: true, message: '请选择知识产权类型' }]"
              >
                <el-select
                  v-model="target.zscqlx"
                  placeholder="请选择"
                  @change="() => (target.zscqxl = '')"
                  style="width: 100%"
                >
                  <el-option label="专利" value="专利" />
                  <el-option label="商标" value="商标" />
                  <el-option label="作品（著作权）" value="作品" />
                  <el-option label="商业秘密" value="商业秘密" />
                  <el-option label="集成电路布图设计" value="集成电路布图设计" />
                  <el-option label="植物新品种" value="植物新品种" />
                  <el-option label="地理标志" value="地理标志" />
                  <el-option label="数据" value="数据" />
                  <el-option label="其他" value="其他" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="isPatent(target.zscqlx)">
              <el-form-item label="知识产权小类">
                <el-select v-model="target.zscqxl" placeholder="请选择" style="width: 100%">
                  <el-option label="发明专利" value="发明专利" />
                  <el-option label="实用新型专利" value="实用新型专利" />
                  <el-option label="外观设计专利" value="外观设计专利" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="业务类型">
                <el-select v-model="target.ywlx" placeholder="请选择" style="width: 100%">
                  <el-option label="转让" value="转让" />
                  <el-option label="许可" value="许可" />
                  <el-option label="作价入股" value="作价入股" />
                  <el-option label="其他" value="其他" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否优先受让">
                <el-radio-group v-model="target.sfyxsr">
                  <el-radio label="是">是</el-radio>
                  <el-radio label="否">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                label="权证编号"
                prop="qzbm"
                :rules="[{ required: true, message: '请输入权证编号' }]"
              >
                <el-input v-model="target.qzbm" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="权证编号数量">
                <el-input-number
                  v-model="target.qzbmCount"
                  :min="1"
                  :precision="0"
                  placeholder="请输入"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="交易份额">
                <el-input v-model="target.jyfe" placeholder="请输入" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="权利人">
                <el-input v-model="target.qlr" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发明(设计)人">
                <el-input v-model="target.fmr" placeholder="请输入" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="共有情况">
                <el-select v-model="target.gyqk" placeholder="请选择" style="width: 100%">
                  <el-option label="无共有" value="无共有" />
                  <el-option label="有共有" value="有共有" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="许可/质押等他项权利情况">
            <el-input
              v-model="target.xkyzqt"
              type="textarea"
              :rows="3"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="其他信息">
            <el-input
              v-model="target.qtxx"
              type="textarea"
              :rows="3"
              placeholder="请输入"
            />
          </el-form-item>
        </el-form>
      </div>

      <div style="margin: 16px 0 24px">
        <el-button @click="addTarget">+ 添加标的</el-button>
      </div>

      <div class="button flex-center">
        <el-button type="primary" @click="$emit('aChange', 'tab2')">上一步</el-button>
        <el-button type="primary" @click="doStaging">暂存</el-button>
        <el-button type="primary" @click="doSubmit">下一步</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["id", "cfrom"],
  data() {
    return {
      bdxxs: [this.emptyTarget()],
    };
  },
  methods: {
    emptyTarget() {
      return {
        zscqlx: "",
        zscqxl: "",
        ywlx: "",
        sfyxsr: "否",
        qzbm: "",
        qzbmCount: null,
        jyfe: "",
        qlr: "",
        fmr: "",
        gyqk: "",
        xkyzqt: "",
        qtxx: "",
      };
    },
    isPatent(type) {
      return type === "专利";
    },
    addTarget() {
      this.bdxxs.push(this.emptyTarget());
    },
    removeTarget(idx) {
      this.bdxxs.splice(idx, 1);
    },
    validateAll() {
      const promises = this.bdxxs.map((_, idx) => {
        const ref = this.$refs["form_" + idx];
        const formRef = Array.isArray(ref) ? ref[0] : ref;
        return new Promise((resolve) => {
          if (!formRef) return resolve(true);
          formRef.validate((valid) => resolve(valid));
        });
      });
      return Promise.all(promises).then((results) => results.every(Boolean));
    },
    doStaging() {
      const value = { bdxxs: JSON.parse(JSON.stringify(this.bdxxs)) };
      if (this.id) value.id = this.id;
      this.$emit("aStagin", value);
    },
    async doSubmit() {
      const valid = await this.validateAll();
      if (valid) {
        const value = { bdxxs: JSON.parse(JSON.stringify(this.bdxxs)) };
        if (this.id) value.id = this.id;
        this.$emit("aChange", "tab4", value);
      }
    },
  },
  watch: {
    cfrom() {
      if (!this.cfrom || !this.cfrom.id) return;
      if (this.cfrom.bdxxs) {
        let arr = this.cfrom.bdxxs;
        if (typeof arr === "string") {
          try {
            arr = JSON.parse(arr);
          } catch (e) {
            arr = null;
          }
        }
        if (Array.isArray(arr) && arr.length > 0) {
          this.bdxxs = arr;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab_content {
  margin: 0 30px;
  .tab_title {
    font-size: 18px;
    font-weight: 500;
  }
  .tab_form {
    margin-top: 20px;
    .target-block {
      border: 1px solid #e4e7ed;
      border-radius: 4px;
      padding: 20px 20px 4px;
      margin-bottom: 20px;
      .target-block-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        .block-index {
          font-size: 15px;
          font-weight: 500;
        }
      }
      ::v-deep .el-form {
        .el-form-item:not(.is-error) .el-form-item__label,
        .el-input__inner,
        .el-textarea__inner,
        .el-radio__label,
        .el-select .el-input .el-input__inner {
          color: inherit;
        }
        .el-input-number .el-input__inner {
          color: inherit;
        }
      }
    }
    .button {
      button {
        width: 160px;
        margin: 0 24px;
        display: block;
      }
    }
  }
}
</style>
